import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { first } from 'rxjs/internal/operators';
import { FirebaseTourModel } from '../data-model/tour.model';
import { DatabaseService } from '../services/database.service';

@Component({
  selector: 'app-selector-tour',
  templateUrl: './selector-tour.component.html',
  styleUrls: ['./selector-tour.component.scss']
})
export class SelectorTourComponent implements OnInit {

  textoInstruccion = 'Selecciona continente';
  opcionesSeleccion = [];
  seleccionActual = [];
  opcionesContinente = [];
  opcionesPais = [];
  opcionesCiudad = [];
  opcionesTour = [];
  
  
  constructor(
    public db: DatabaseService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.db.getContinents()
      .get().then(data => {
        this.opcionesContinente = [];
        data.forEach(d => {
          var continente = {
            image: d.data()['image'],
            name: d.id,
            label: d.data()['label'],
          };
          this.opcionesContinente.push(continente);
        });
        this.opcionesSeleccion.push(this.opcionesContinente);
      });
  }


  seleccionaContinente(insertar, continentName) {
    if (insertar) {
      this.textoInstruccion = 'Selecciona país';
      this.seleccionActual.push(continentName);
      //this.opcionesSeleccion.push(this.opcionesPais);

      this.db.getCountries(continentName)
        .get().then(data => {
          this.opcionesPais = [];
          data.forEach(d => {
            var pais = {
              image: d.data()['image'],
              name: d.id,
              label: d.data()['label'],
            };
            this.opcionesPais.push(pais);
          });
          this.opcionesSeleccion.push(this.opcionesPais);
        });
    }
    else {
      this.seleccionActual = [];
      this.opcionesSeleccion = this.opcionesSeleccion.slice(0, 1);
    }

  }
  seleccionaPais(insertar, countryName) {
    if (insertar) {
      this.textoInstruccion = 'Selecciona ciudad';
      this.seleccionActual.push(countryName);
      //this.opcionesSeleccion.push(this.opcionesCiudad);

      this.db.getCities(countryName)
        .get().then(data => {
          this.opcionesCiudad = [];
          data.forEach(d => {
            var ciudad = {
              image: d.data()['image'],
              name: d.id,
              label: d.data()['label'],
            };
            this.opcionesCiudad.push(ciudad);
          });
          this.opcionesSeleccion.push(this.opcionesCiudad);
        });
    }
    else {
      this.seleccionActual = this.seleccionActual.slice(0, 1);
      this.opcionesSeleccion = this.opcionesSeleccion.slice(0, 2);
    }
  }
  seleccionaCiudad(insertar, cityName) {
    if (insertar) {
      this.textoInstruccion = 'Selecciona el tour';
      this.seleccionActual.push(cityName);
      //this.opcionesSeleccion.push(this.opcionesTour);

      this.db.getTours(cityName)
        .get().then(data => {          
          this.opcionesTour = [];
          data.forEach(d => {
            var tourData=FirebaseTourModel.objectToModel(d.data());
            tourData.id=d.id;
            if (tourData.imageUrl) {
              tourData.imageSanitizer = this.sanitizer.bypassSecurityTrustResourceUrl(tourData.imageUrl);
            }
            else{
              tourData.imageSanitizer=null;
            }
            this.opcionesTour.push(tourData);
        });
          this.opcionesSeleccion.push(this.opcionesTour);
        });
    }
    else {
      this.seleccionActual = this.seleccionActual.slice(0, 2);
      this.opcionesSeleccion = this.opcionesSeleccion.slice(0, 3);
    }
  }
}
